"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assistantTonePreferencesSchema = exports.baseToneSchema = void 0;
const zod_1 = require("zod");
exports.baseToneSchema = zod_1.z.enum(["default", "professional", "casual", "concise"]);
exports.assistantTonePreferencesSchema = zod_1.z.strictObject({
    baseTone: exports.baseToneSchema,
    customInstructions: zod_1.z.string().max(3000).optional(),
});
